module.exports = __webpack_public_path__ + "img/1.59437f50.jpg";